'use strict';

export const arrayToObj = (array, key) => array.reduce((obj, item) => {
	obj[item[key]] = item;
	return obj;
}, {});

//=================================================================================================================

export const objToArray = obj => Object.keys(obj).map(key => obj[key]);

//=================================================================================================================

export const deepCopy = obj => {
	const clone = Array.isArray(obj) ? [] : {};
	for (let key in obj) {
		const value = obj[key];
		clone[key] = value !== null && typeof(value) === 'object' ? deepCopy(value) : value;
	}
	return clone;
};

//=================================================================================================================

export const toRouteParams = ({ type, value }) => value ? `${type}-${value}` : type;

//=================================================================================================================

export const copyToClipboard = txt => {
	try {
		const ta = document.createElement('textarea');
		ta.style.position = 'absolute';
		ta.style.left = -999999999;
		ta.value = txt;
		document.body.appendChild(ta);

		ta.select();
		document.execCommand("copy");

		document.body.removeChild(ta);
		return true;
	}
	catch(err) {
		return false;
	}
};
